import { NavLink } from 'react-router-dom'
import 'swiper/swiper.scss'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

// import { removeCard } from '@src/store/ducks/user/thunks'
import style from '@src/pages/UserPage/UserPage.module.scss'
import { IndividualsPanel }
  from '@src/components/IndividualsPanel/IndividualsPanel'
import { PersonalAccount } from '@src/components/PersonalAccaunt/PersonalAccount'
import { Button } from '@src/components/Button/Button'
import { MyTariffPlan } from '@src/components/MyTariffPlan/MyTariffPlan'
import { Notification } from '@src/components/Notification/Notification'
import { Footer } from '@src/components/Footer/Footer'
import { SliderSwiper } from '@src/components/SliderSwiper/SliderSwiper'
import {
  selectUserCurrentAddresses, selectUserInfo,
  selectUserServices,
} from '@src/store/ducks/user/selectors'
import { SubscribeBlock } from '@src/components/SubscribeBlock/SubscribeBlock'
import { selectPromotions } from '@src/store/ducks/promotion/selectors'
import {
  selectSubscriptionsIsLoadingChange,
  selectSubscriptionsIsSuccessChange,
  selectSubscriptionsList, selectSubscriptionsSuccessMessage,
} from '@src/store/ducks/subscriptions/selectors'
import { useCallback, useEffect, useState } from 'react'
import {
  resetSubscriptions,
  setIsSuccessChangeSubscription,
  setSubscriptionSuccessMessage,
} from '@src/store/ducks/subscriptions/reducer'
import { addSubscription, closeSubscription, getSubscriptions } from '@src/store/ducks/subscriptions/thunks'
import { SubscriptionsType } from '@src/store/ducks/subscriptions/types'
import { AppDispatch } from '@src/store/store'
import { Modal } from '@src/components/common/Modal/Modal'
import { setPageTitle } from '@src/store/ducks/app/reducer'
import { ChangeTariff } from '@src/pages/ChangeTariff/ChangeTariff'
import { userApi } from '@src/api/user-api'
import { Store } from 'react-notifications-component'
import { selectRecurrentCard } from '@src/store/ducks/pay/selectors'
import { getRecurrentCard } from '@src/store/ducks/pay/thunks'

export const UserPage = () => {
  const dispatch = useDispatch<AppDispatch>()
  const services = useSelector(selectUserServices)
  const promotions = useSelector(selectPromotions)
  const subscriptions = useSelector(selectSubscriptionsList)
  const currentAddresses = useSelector(selectUserCurrentAddresses)
  const [select, setSelect] = useState<SubscriptionsType | null>(null)
  const isSuccessChange = useSelector(selectSubscriptionsIsSuccessChange)
  const isLoadingChange = useSelector(selectSubscriptionsIsLoadingChange)
  const successMessage = useSelector(selectSubscriptionsSuccessMessage)
  const user = useSelector(selectUserInfo)
  const recurrentCard = useSelector(selectRecurrentCard)

  useEffect(() => {
    dispatch(setPageTitle('Главная страница |Личный кабинет для абонентов КОСМОС Телеком'))
  }, [dispatch])

  useEffect(() => () => {
    dispatch(resetSubscriptions())
  }, [dispatch])

  useEffect(() => {
    if (currentAddresses) {
      dispatch(getSubscriptions(currentAddresses.accountId))
      dispatch(getRecurrentCard())
    }
  }, [currentAddresses, dispatch])

  const closeModal = useCallback(() => {
    setSelect(null)
    dispatch(setIsSuccessChangeSubscription(false))
    dispatch(setSubscriptionSuccessMessage(''))
  }, [dispatch])

  const handleChange = useCallback(() => {
    if (select) {
      if (select.isActive) {
        dispatch(closeSubscription(select.serviceId))
      } else {
        dispatch(addSubscription(select.tariffId))
      }
    }
  }, [dispatch, select])
  const handleRemoveCard = useCallback(async () => {
    console.log('currentAddresses?.accountId = ', currentAddresses?.accountId)
    if (!currentAddresses?.accountId) {
      alert('Не удалось определить номер лицевого счёта')
      return
    }

    if (!window.confirm('Вы уверены, что хотите удалить привязанную платёжную карту? Это действие нельзя отменить.')) {
      return
    }

    try {
      await userApi.removeCard(currentAddresses?.accountId)
      console.log('after await userApi.removeCard(accountId)')

      Store.addNotification({
        title: 'Готово!',
        message: 'Платёжная карта успешно удалена',
        type: 'success',
        insert: 'top',
        container: 'top-right',
        dismiss: {
          duration: 5000,
        },
      })
    } catch (error) {
      console.error('Ошибка при удалении карты:', error)
      alert('Не удалось удалить карту. Попробуйте позже.')
    }
  }, [currentAddresses?.accountId])
  console.log('кабинет', promotions)
  return (
    <div>
      <IndividualsPanel />
      <div className={cn(style.container, 'container')}>
        <div>
          <SliderSwiper data={promotions.data} />
        </div>
        <div className={style.user_box}>
          <div className={style.headerBlock}>
            <h2>Личный кабинет</h2>
            {!user.isSubscriber && (
              <div className={`${style.btn}`}>
                <NavLink className={style.text} to="/moving-new-address">
                  <Button type="text" className={style.btnSize}>
                    Переезд на новый адрес
                  </Button>
                </NavLink>
                <NavLink className={style.text} to="/block-service">
                  <Button className={style.btnSize} type="text">
                    Временная блокировка
                  </Button>
                </NavLink>

                <div className="new_delete_btn" style={{ marginLeft: '10px' }}>
                  {!!recurrentCard?.lastCard && (
                    <Button
                      className={style.btnSize}
                      type="text"
                      onClickFunc={handleRemoveCard}
                    >
                      Удалить привязанную карту
                    </Button>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className={style.bodyBlock}>
            <div className={style.leftPart}>
              <PersonalAccount />
              <div className={style.statusShow}>
                <Notification />
              </div>
            </div>
            <div className={style.rightPart}>
              <MyTariffPlan buttons />

              {user.isSubscriber && services.tariff[0]?.serviceId && (
                <ChangeTariff isHome serviceId={services.tariff[0].serviceId} />
              )}

              {!user.isSubscriber && (
                <>
                  {!!subscriptions.filter((item) => item.isActive).length && (
                    <div className={style.subscriptions}>
                      <div className={style.header}>
                        <h3>Актуальные подписки</h3>
                        {/* <NavLink className={style.subscriptionsA} to="/subscriptions">
                    Смотреть все подписки
                  </NavLink>
                  <NavLink className={style.subscriptionsB} to="/subscriptions">
                    Все подписки
                  </NavLink> */}
                      </div>
                      {subscriptions.map((el) => el.isActive && (
                        <SubscribeBlock
                          key={el.id}
                          title={(
                            <div>
                              {el.name}
                              {!!el.dateEnd?.trim() && (
                                <span className={style.startDate}>
                                  (действует до
                                  {' '}
                                  {moment(el.dateEnd, 'DD.MM.YYYY').format('DD.MM.YYYY')}
                                  )
                                </span>
                              )}
                            </div>
                          )}
                          cost={el.price}
                          descriptionTariff={el.description}
                          btn={!el.dateEnd?.trim()}
                          btnClick={() => { setSelect(el) }}
                          btnName="Отключить"
                          btnType="secondary"
                          btnOutline
                        />
                      ))}
                    </div>
                  )}

                  {!!subscriptions.filter((item) => !item.isActive).length && (
                    <div className={style.subscriptions}>
                      <div className={style.header}>
                        <h3>Доступные подписки</h3>
                      </div>
                      {subscriptions.map((el) => !el.isActive && (
                        <SubscribeBlock
                          key={el.id}
                          title={(
                            <div>
                              {el.name}
                              {!!el.dateEnd?.trim() && (
                                <span className={style.startDate}>
                                  (действует до
                                  {' '}
                                  {moment(el.dateEnd, 'DD.MM.YYYY').format('DD.MM.YYYY')}
                                  )
                                </span>
                              )}
                            </div>
                          )}
                          cost={el.price}
                          descriptionTariff={el.description}
                          btnDisabled={!!el.dateEnd?.trim()}
                          btn
                          btnClick={() => { setSelect(el) }}
                          btnName="Подключить"
                          btnType="primary"
                        />
                      ))}
                    </div>
                  )}
                </>
              )}

              {!!services.equipment.length && (
                <div className={style.equipment}>
                  <h3>Используемое оборудование</h3>
                  {services.equipment.map((el) => (
                    <SubscribeBlock className="styleNull" key={el.goodName} title={el.goodName} cost={el.price} />
                  ))}
                </div>
              )}
              <div className={style.statusShow2}>
                <Notification />
              </div>
              <div className={cn(style.btn, style.bottomBtn)}>
                <NavLink
                  className={style.text}
                  to="/moving-new-address"
                >
                  <Button
                    type="text"
                    className={style.btnSize}
                  >
                    Переезд на новый адрес
                  </Button>
                </NavLink>

                <NavLink
                  className={style.text}
                  to="/block-service"
                >
                  <Button
                    className={style.btnSize}
                    type="text"
                  >
                    Временная блокировка
                  </Button>
                </NavLink>
                <div className="new_delete_btn">
                  {!!recurrentCard?.lastCard && (
                    <Button
                      className={style.btnSize}
                      type="text"
                      onClickFunc={handleRemoveCard}
                    >
                      Удалить привязанную карту
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Modal isOpen={!!select} close={closeModal}>
        {isSuccessChange ? (
          <>
            <div className={style.confirmActions}>
              {successMessage}
            </div>
          </>
        ) : (
          <>
            <div className={style.confirmActions}>
              Подтвердите Ваше действие по изменениям
            </div>
            <div className={style.actions}>
              {select && (
                <Button
                  className={style.btnSize}
                  loading={isLoadingChange}
                  onClickFunc={() => handleChange()}
                >
                  Подтвердить
                </Button>
              )}
              <Button
                className={style.btnSize}
                disabled={isLoadingChange}
                type="textSecondary"
                onClickFunc={() => setSelect(null)}
              >
                Отменить
              </Button>
            </div>
          </>
        )}
      </Modal>
    </div>
  )
}
